import React, { useState } from 'react';
import { StepContainer, StepNavigation } from '../components';
import { StepProps, useFormContext } from '../context';
import { useFormValidation } from '../hooks';
import { ReferenciasInfo } from '../sections';

export const Step20A_ReferenciaComercial: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.referenceComercial) newErrors.referenceComercial = 'Nome da referência é obrigatório';
    if (!data.referenceComercialPhone) newErrors.referenceComercialPhone = 'Telefone da referência é obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ referenceComercial: data.referenceComercial, referenceComercialPhone: data.referenceComercialPhone });
  };

  const handleFieldChange = (newData: Partial<typeof data>) => {
    // Mapear dados da seção ReferenciasInfo para os campos do contexto
    if ('name' in newData) {
      updateField('referenceComercial', newData.name);
    }
    if ('phone' in newData) {
      updateField('referenceComercialPhone', newData.phone);
    }
    
    Object.keys(newData).forEach(key => {
      if (errors[key]) {
        setErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors[key];
          return newErrors;
        });
      }
    });
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-2">Agora, preencha 1 referência de confiança:</p>
        
        <p className="text-muted-foreground text-sm mb-4">
          Nos diga uma pessoa (amiga, conhecida ou até uma cliente em potencial) que confia em você e que pode confirmar sua dedicação.
        </p>

        <p className="text-sm mb-4">
          👉 Pode ser alguém que já compra com você, que tem interesse em comprar, ou apenas uma pessoa próxima que acredita no seu trabalho. 😊
        </p>

        <div className="bg-amber-50 border border-amber-200 rounded-md p-3 mb-4">
          <p className="text-amber-900 text-sm">
            <span className="font-semibold">⚠️ Atenção!</span> Necessário ser <span className="font-semibold">diferente das referências anteriores.</span>
          </p>
        </div>

        <p className="text-muted-foreground text-sm mb-4">
          Preencha nome e a relação que essa referência tem com você..
        </p>

        <div className="bg-amber-50 border border-amber-200 rounded-md p-3 mb-4">
          <p className="text-amber-900 text-sm">
            Por exemplo: <span className="font-semibold">Maria - amiga</span>
          </p>
        </div>
      </div>
      <ReferenciasInfo
        numero={1}
        data={{
          name: data.referenceComercial || '',
          phone: data.referenceComercialPhone || '',
        }}
        onChange={handleFieldChange}
      />

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step20A_ReferenciaComercial;
